export var getStudentRowId = function (studentId) {
    return "student_" + studentId;
};
